import React from 'react'
import { Row, Col } from 'react-bootstrap'

import Card from 'components/common/cards/Card'
import Icon from 'components/common/Icon'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import colors from 'utility/colors'

const ShareLink = ({ id, link = '', buttonCopy = '', style = {} }) => {
	return (
		<Row>
			<Col xs='12' md='8' lg='9'>
				<Card
					style={{
						marginTop: 0,
						height: 'auto',
						background: colors.WHITE,
						padding: '10px 15px 10px 15px',
						marginBottom: 10,
						...style,
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							flexWrap: 'nowrap',
						}}
					>
						<Icon icon='link' style={{ minWidth: 16 }} />
						<a id={id} href={link} target='_blank' style={{ width: '100%' }}>
							<Text
								style={{
									paddingLeft: 15,
									paddingRight: 15,
									marginBottom: 0,
									paddingBottom: 0,
									whiteSpace: 'nowrap',
								}}
								color={colors.PRIMARY}
							>
								{link}
							</Text>
						</a>
					</div>
				</Card>
			</Col>
			{buttonCopy ? (
				<Col xs='12' md='4' lg='3'>
					<a href={link} target={'_blank'}>
						<Button background={colors.GRAY} style={{ marginBottom: 15, marginTop: 10 }}>
							{buttonCopy}
						</Button>
					</a>
				</Col>
			) : null}
		</Row>
	)
}

export default ShareLink
